import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PlaceholderLabelDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (label: string) => void;
  documentColor?: string;
}

export function PlaceholderLabelDialog({
  open,
  onOpenChange,
  onConfirm,
  documentColor = "#ef4444",
}: PlaceholderLabelDialogProps) {
  const [label, setLabel] = useState("");

  const handleConfirm = () => {
    onConfirm(label.trim() || "New Slide");
    setLabel("");
    onOpenChange(false);
  };

  const handleCancel = () => {
    setLabel("");
    onOpenChange(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-base sm:text-lg">Add Placeholder Slide</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="py-4">
          <Label htmlFor="placeholder-label" className="text-sm sm:text-base">
            Slide Title
          </Label>
          <Input
            id="placeholder-label"
            type="text"
            placeholder="e.g., Market Analysis, Team Slide..."
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            onKeyDown={handleKeyDown}
            className="mt-2 text-base"
            maxLength={255}
            autoFocus
            data-testid="input-placeholder-label"
          />
        </div>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel
            onClick={handleCancel}
            className="min-h-[44px] text-base"
            data-testid="button-cancel-placeholder"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="min-h-[44px] text-base text-white"
            style={{ backgroundColor: documentColor }}
            data-testid="button-confirm-placeholder"
          >
            Add Placeholder
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
